import React from "react"
import { Col, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import InspectionAction from "store/inspection-resource/actions"
import Skeleton from "react-loading-skeleton"

function ListOrder({
  setSelectedInspection,
  callbackGetChecklist,
  callbackGetDetailSize,
  selectedInspection,
  setCheckAllInspectorEditable,
  setCheckAllProducerEditable,
}) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  return (
    <Row>
      {store.inspection.order.loading ? (
        <Skeleton count={5} />
      ) : (
        <>
          {store.inspection.order.data.map((i, k) => (
            <Col
              md="12"
              className={`p-2 px-4 mt-2 ${
                selectedInspection == i?.id ? "bg-dark text-white" : "bg-light"
              }`}
              role="button"
              key={k}
              onClick={() => {
                setSelectedInspection(i.id)
                dispatch(
                  InspectionAction.getOrderDetail(i.id, callbackGetChecklist)
                )
                dispatch(
                  InspectionAction.getOrderDetailSize(
                    i.id,
                    callbackGetDetailSize
                  )
                )
                setCheckAllInspectorEditable(false)
                setCheckAllProducerEditable(false)
              }}
            >
              <span>
                {i.orderNumber}/{i.customerName}/{i.productName}
              </span>
            </Col>
          ))}
        </>
      )}
    </Row>
  )
}

export default ListOrder
